import { RpcClientV2 } from 'rpc-client-utils';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
// @ts-expect-error untyped module
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import {
  createGetBusinessUnitDisplaysForUser,
  getBusinessUnitDisplaysForUser,
} from '../api/BusinessUnitDropdownChirpAPI';

export const createBusinessUnitDropdownReferenceResolverChirp = (options?: {
  httpClient?: RpcClientV2;
}) =>
  createSimpleCachedReferenceResolver({
    cacheKey: CacheKeys.BUSINESS_UNIT_DROPDOWN,
    createFetchData: ({ httpClient }: { httpClient: RpcClientV2 }) =>
      createGetBusinessUnitDisplaysForUser({ httpClient }),
    fetchData: getBusinessUnitDisplaysForUser,
    ...options,
  });

export default createBusinessUnitDropdownReferenceResolverChirp();
